import type { ContentOperation } from '../types';

type ContentOperationIntUpdate =
    | number
    | {
          increment: number;
      };

export type ContentOperationUpdate = Omit<Partial<ContentOperation>, 'cursor' | 'target'> & {
    cursor?: ContentOperationIntUpdate;
    target?: ContentOperationIntUpdate;
};

/**
 * Apply an update to a content operation.
 */
export function updateContentOperation(
    operation: ContentOperation,
    update: ContentOperationUpdate
): ContentOperation {
    return {
        ...operation,
        updateId: operation.updateId + 1,
        updatedAt: Date.now(),
        status: update.status ?? operation.status,
        payload: update.payload ?? operation.payload,
        cursor:
            update.cursor !== undefined
                ? updateInt(operation.cursor, update.cursor)
                : operation.cursor,
        target:
            update.target !== undefined
                ? updateInt(operation.target, update.target)
                : operation.target,
    };
}

function updateInt(value: number, update: ContentOperationIntUpdate): number {
    if (typeof update === 'number') {
        return update;
    }

    return value + update.increment;
}
